import {
  GetSnapshot,
  PostSnapshotByPeriodo,
  PutSnapshotEvaluacion,
  DeleteSnapshotEvaluacion,
  GetResumen,
  GetResumenAsesor,
  PutCambiarVendedor,
  State as ComisionMembresiaState
} from "../../../reducers/comisionMembresia";

export interface ReporteAsesorStore
  extends GetSnapshot,
    PostSnapshotByPeriodo,
    PutSnapshotEvaluacion,
    DeleteSnapshotEvaluacion,
    GetResumen,
    GetResumenAsesor,
    PutCambiarVendedor {}

export const reporteAsesorStore: (state) => ReporteAsesorStore = state => {
  const comisionMembresia: ComisionMembresiaState = state.comisionMembresia;

  return {
    snapshot: comisionMembresia.snapshot,
    gettingSnapshot: comisionMembresia.gettingSnapshot,
    gettingSnapshotError: comisionMembresia.gettingSnapshotError,

    postSnapshotResult: comisionMembresia.postSnapshotResult,
    postingSnapshotByPeriodo: comisionMembresia.postingSnapshotByPeriodo,
    postingSnapshotByPeriodoError:
      comisionMembresia.postingSnapshotByPeriodoError,

    putSnapshotEvaluacionResult: comisionMembresia.putSnapshotEvaluacionResult,
    puttingSnapshotEvaluacion: comisionMembresia.puttingSnapshotEvaluacion,
    puttingSnapshotEvaluacionError:
      comisionMembresia.puttingSnapshotEvaluacionError,

    deleteSnapshotEvaluacionResult:
      comisionMembresia.deleteSnapshotEvaluacionResult,
    deletingSnapshotEvaluacion: comisionMembresia.deletingSnapshotEvaluacion,
    deletingSnapshotEvaluacionError:
      comisionMembresia.deletingSnapshotEvaluacionError,

    resumenSnapshot: comisionMembresia.resumenSnapshot,
    gettingResumenSnapshot: comisionMembresia.gettingResumenSnapshot,
    gettingResumenSnapshotError: comisionMembresia.gettingResumenSnapshotError,

    cambiarVendedorResult: comisionMembresia.cambiarVendedorResult,
    puttingCambiarVendedor: comisionMembresia.puttingCambiarVendedor,
    puttingCambiarVendedorError: comisionMembresia.puttingCambiarVendedorError,

    resumenAsesor: comisionMembresia.resumenAsesor,
    gettingResumenAsesor: comisionMembresia.gettingResumenAsesor,
    gettingResumenAsesorError: comisionMembresia.gettingResumenAsesorError
  };
};
